import type { IJodit } from 'jodit/types/types';
import type { JoditCustomButtonMap, JoditToolbarConfig } from './jodit-toolbar.types';

/** Configuration builder parameters */
export type JoditConfigParams = {
  userConfig: Partial<IJodit['options']>;
  placeholder: string;
  readonly: boolean;
  disabled: boolean | undefined;
  height: number | string;
  toolbar: JoditToolbarConfig;
  customButtons: JoditCustomButtonMap;
};

/** Build effective Jodit configuration from component inputs Type-safe alternative to inline `any` typed config objects */
export function buildJoditConfig(
  defaultConfig: Partial<IJodit['options']>,
  params: JoditConfigParams
): IJodit['options'] {
  const config: Partial<IJodit['options']> = {
    ...defaultConfig,
    ...params.userConfig,
    placeholder: params.placeholder || defaultConfig.placeholder,
    readonly: params.readonly,
    disabled: params.disabled,
    height: params.height,
    controls: params.customButtons as IJodit['options']['controls'],
  };

  // Handle toolbar configuration
  if (typeof params.toolbar === 'string' || Array.isArray(params.toolbar)) {
    config.toolbar = true;
    config.buttons = params.toolbar as IJodit['options']['buttons'];
  } else {
    config.toolbar = params.toolbar;
  }

  return config as IJodit['options'];
}
